<template>
  <div>
    <div class="banner">
      <div class="banner-center">
        <div class="textbox">
          <div class="banner-text1">互联省公共服务平台</div>
          <div class="banner-text2">
            助力建设全国统一大市场，优化市场营商环境
          </div>
        </div>

        <div>
          <img
            src="../../assets/img/banner2/9-2.png"
            alt=""
            class="banner-img"
          />
        </div>
      </div>
    </div>

    <!-- 互认具体步骤 -->

    <div class="box1">
      <mytitle title="对接实施具体步骤" style="margin-top: 64px"></mytitle>

      <div class="stepbox">
        <div class="stepitembg">
          <div class="overtop"></div>

          <div class="stepitem">
            <div class="step-top">
              <img
                src="../../assets/img/step/step-top.svg"
                alt=""
                style="width: 133px; height: 70px"
              />
            </div>
            <div class="stepindex">1</div>

            <div class="stepico">
              <img
                src="../../assets/img/step/step-ico.svg"
                alt=""
                style="width: 32px; height: 35px"
              />
            </div>

            <div class="stepTitle">阅读接入指南</div>

            <div class="stepText">
              预览、下载《远程异地评标和评标专家库共享技术标准_电子交易系统接入指南》
            </div>

            <div
              style="
                display: flex;
                margin-top: 44px;
                justify-content: space-evenly;
                padding: 0 10px;
              "
            >
              <el-button class="btn2" @click="Previewzn(1, 1)">预览</el-button>
              <el-button type="primary" class="btn1" @click="downzn(1, 1)"
                >下载</el-button
              >
            </div>
          </div>
        </div>

        <div class="stepitembg">
          <div class="overtop"></div>

          <div class="stepitem">
            <div class="step-top">
              <img
                src="../../assets/img/step/step-top.svg"
                alt=""
                style="width: 133px; height: 70px"
              />
            </div>
            <div class="stepindex">2</div>

            <div class="stepico">
              <img
                src="../../assets/img/step/step-ico.svg"
                alt=""
                style="width: 32px; height: 35px"
              />
            </div>

            <div class="stepTitle">准备环境</div>

            <div class="stepText">
              根据《远程异地评标技术标准_电子交易系统接入指南》准备远程异地评标目录服务组件所需的网络设施环境、硬件设备资源
            </div>

            <div
              style="
                display: flex;
                margin-top: 24px;
                justify-content: space-evenly;
                padding: 0 10px;
              "
            >
              <el-button class="btn2" @click="Previewzn(1)">预览</el-button>
              <el-button type="primary" class="btn1" @click="downzn(1, 2)"
                >下载</el-button
              >
            </div>
          </div>
        </div>

        <div class="stepitembg">
          <div class="overtop"></div>
          <contactUs v-show="showContactUs1"></contactUs>
          <div class="stepitem">
            <div class="step-top">
              <img
                src="../../assets/img/step/step-top.svg"
                alt=""
                style="width: 133px; height: 70px"
              />
            </div>
            <div class="stepindex">3</div>

            <div class="stepico">
              <img
                src="../../assets/img/step/step-ico.svg"
                alt=""
                style="width: 32px; height: 35px"
              />
            </div>

            <div class="stepTitle">部署远程异地评标<br />目录服务组件</div>

            <div class="stepText">
              联系中国招标投标公共服务平台运维实施人员部署远程异地评标共享目录服务组件
            </div>

            <div
              style="
                display: flex;
                margin-top: 34px;
                justify-content: space-evenly;
                padding: 0 10px;
              "
            >
              <el-button
                class="btn2"
                style="width: 256px"
                @mouseover="showContactUs1 = true"
                @mouseleave="showContactUs1 = false"
                @click="openDialog"
                >联系我们</el-button
              >
            </div>
          </div>
        </div>

        <div class="stepitembg">
          <div class="overtop"></div>

          <div class="stepitem">
            <div class="step-top">
              <img
                src="../../assets/img/step/step-top.svg"
                alt=""
                style="width: 133px; height: 70px"
              />
            </div>
            <div class="stepindex">4</div>

            <div class="stepico">
              <img
                src="../../assets/img/step/step-ico.svg"
                alt=""
                style="width: 32px; height: 35px"
              />
            </div>

            <div class="stepTitle">配置场所目录范围</div>

            <div class="stepText">
              通过远程异地评标与评标专家库共享目录服务组件公共服务平台自助管理终端，配置场所目录范围
            </div>
          </div>
        </div>

        <div class="stepitembg">
          <div class="overtop"></div>

          <div class="stepitem">
            <div class="step-top">
              <img
                src="../../assets/img/step/step-top.svg"
                alt=""
                style="width: 133px; height: 70px"
              />
            </div>
            <div class="stepindex">5</div>

            <div class="stepico">
              <img
                src="../../assets/img/step/step-ico.svg"
                alt=""
                style="width: 32px; height: 35px"
              />
            </div>

            <div class="stepTitle">配置专家库目录范围</div>

            <div class="stepText">
              通过远程异地评标与评标专家库共享目录服务组件公共服务平台自助管理终端，配置专家库目录范围
            </div>
          </div>
        </div>

        <div class="stepitembg">
          <div class="overtop"></div>

          <div class="stepitem">
            <div class="step-top">
              <img
                src="../../assets/img/step/step-top.svg"
                alt=""
                style="width: 133px; height: 70px"
              />
            </div>
            <div class="stepindex">6</div>

            <div class="stepico">
              <img
                src="../../assets/img/step/step-ico.svg"
                alt=""
                style="width: 32px; height: 35px"
              />
            </div>

            <div class="stepTitle">确认发布主副场所目录</div>

            <div class="stepText">
              通过远程异地评标与评标专家库共享目录服务组件公共服务平台自助管理终端，确认发布主副场所目录
            </div>
          </div>
        </div>

        <div class="stepitembg">
          <div class="overtop"></div>

          <div class="stepitem">
            <div class="step-top">
              <img
                src="../../assets/img/step/step-top.svg"
                alt=""
                style="width: 133px; height: 70px"
              />
            </div>
            <div class="stepindex">7</div>

            <div class="stepico">
              <img
                src="../../assets/img/step/step-ico.svg"
                alt=""
                style="width: 32px; height: 35px"
              />
            </div>

            <div class="stepTitle">确认发布主副专家库目录</div>

            <div class="stepText">
              通过远程异地评标与评标专家库共享目录服务组件公共服务平台自助管理终端，确认发布主副专家库目录
            </div>
          </div>
        </div>

        <div style="width: 288px"></div>
      </div>
    </div>

    <!-- 互联交易系统目录 -->

    <systemCatalog
      title="互联省公共服务平台目录"
      placeholder="请输入互联省公共服务平台目录名称搜索"
      type="2"
    ></systemCatalog>

    <infoDailog
      :showRegister.sync="showRegister"
      :registrationType.sync="registrationType"
      @confirm="confirm"
      @canDownload="canDownload"
    ></infoDailog>
  </div>

  <!-- 平台弹框 -->

  <div class="myoverlay" v-if="showoverlay" @click="showoverlay = false">
    <div class="mydialog" @click.stop="clickdialog">
      <div class="dialogtitle">{{ systeminfo.platformName }}</div>
      <div class="dtext">选择交易平台或系统查看</div>

      <div>
        <div class="numbox">
          <div class="dline"></div>
          <div class="dtext2">
            交易系统
            <span class="dtext3">{{ systeminfo.systemList.length }}</span> 个
          </div>
          <div class="dline"></div>
        </div>

        <div
          class="systeminfoBox"
          :class="{ systeminfoBox2: systeminfo.systemList.length === 2 }"
        >
          <div
            class="systemItem"
            v-for="(item, index) in systeminfo.systemList"
            :key="index"
            @click="toPlatformUrl(item)"
          >
            {{ item.tradingSystemName }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import systemCatalog from "../../components/systemCatalog";

import infoDailog from "../infoDailog.vue";
import mytitle from "../../components/title.vue";

import { reactive, toRefs, ref, onMounted, nextTick } from "vue";
import { useRoute } from "vue-router";
const route = useRoute();
import { useRouter } from "vue-router";

const router = useRouter();
import {
  getPublishPlatform,
  platformView,
  endpointDownload,
  documentPreview,
  getProvincePlatformCatalog,
} from "../../utils/axios";
import { ElMessage } from "element-plus";

import { Swiper, SwiperSlide } from "swiper/vue"; // swiper所需组件
// 这是分页器和对应方法，swiper好像在6的时候就已经分离了分页器和一些其他工具
import { Autoplay, Navigation, A11y } from "swiper";
// 引入swiper样式，对应css 如果使用less或者css只需要把scss改为对应的即可
import "swiper/css";
import "swiper/css/navigation";
//默认滑动效果（这里面注释掉的可以不要）
// const onSwiper = swiper => {
// };
// const onSlideChange = e => {
// 	// swiper切换的时候执行的方法
// };
// setup语法糖只需要这样创建一个变量就可以正常使用分页器和对应功能，如果没有这个数组则无法使用对应功能
const modules = [Autoplay, Navigation, A11y];

//  平台轮播按钮
const navigation = ref({
  nextEl: ".swiper-button-next",
  prevEl: ".swiper-button-prev",
});

//上一个
const prevEl = (item, index) => {};
//下一个
const nextEl = () => {};

import contactUs from "../../components/contactUs.vue";

let showContactUs1 = ref(false);

//  平台弹框

let showRegister = ref(false);
let registrationType = ref(-1);
//  打开平台弹框

const openDialog = () => {
  window._czc.push([
    "_trackEvent",
    "省公共服务平台",
    "联系我们",
    "部署远程异地评标目录服务组件",
  ]);
  // showRegister.value = true
  // canDownload()
};
const clickdialog = () => {};
// 跳转视频
const tovideo = () => {
  window.open("https://www.yunpan.com/surl_y9tqAvIvstR", "_blank");
};
//下载工具
const downTool = (type) => {
  if (type == 6) {
    window.open("https://d45a52.link.yunpan.com/lk/surl_y9ktHkJQ6Kr", "_blank");
  }

  if (type == 7) {
    window.open("https://d45a52.link.yunpan.com/lk/surl_y9ktHkJQ6Kr", "_blank");
  }

  if (type == 8) {
    // ElMessage.warning('功能开发中，敬请期待！')
    window.open(
      "http://casharecolumn.oss-cn-beijing.aliyuncs.com/zz-ca-share-column/upload/20240830/44aaa506f31c2eac5206f9e7a32f0f66.zip",
      "_blank"
    );
  }
};
//源码预览
const toymUrl = (type) => {
  // ElMessage.warning('功能开发中，敬请期待！')
  window.open("https://gitee.com/cebpubservice", "_blank");
};
//关闭弹框
const confirm = () => {
  showRegister.value = false;
};

const canDownload = () => {};

//预览 并发送友盟统计
const Previewzn = (type: any, type2: any) => {
  // documentPreview({ documentType: type }).then(res => {
  //     if (type == 8) {
  //         window._czc.push(['_trackEvent', '互认交易平台', '预览', '交易平台接入指南预览'])
  //     }
  //     if (type == 9) {
  //         window._czc.push(['_trackEvent', '互认交易平台', '预览', 'CA互认共享组件环境配置指南'])
  //     }

  //     window.open(res.data.documentUrl, '_blank');
  // }).catch(res => {
  //     ElMessage.warning('功能开发中，敬请期待！')
  // })
  // ElMessage.warning('功能开发中，敬请期待！')
  if (type2 == 1) {
    window._czc.push([
      "_trackEvent",
      "省公共服务平台",
      "预览",
      "电子交易系统接入指南预览",
    ]);
  } else {
    window._czc.push([
      "_trackEvent",
      "省公共服务平台",
      "准备环境",
      "电子交易系统接入指南预览",
    ]);
  }

  window.open(
    "S01远程异地评标和评标专家库共享技术标准_电子交易系统接入指南_20250605_1600.pdf",
    "_blank"
  );
};

//下载 并发送友盟统计

const downzn = (type: any, type2: any) => {
  // if (type == 8) {
  //     window._czc.push(['_trackEvent', '互认交易平台', '下载', '交易平台接入指南下载'])
  // }

  // if (type == 9) {
  //     window._czc.push(['_trackEvent', '互认交易平台', '下载', 'CA互认共享组件环境配置指南'])
  // }

  // let name2 = ''
  // documentPreview({ documentType: type }).then(res => {
  //     name2 = res.data.documentName

  //     endpointDownload({ documentType: type }).then(res => {
  //         var blob = new Blob([res])
  //         let fname = name2 + '.pdf'; //下载文件的名字
  //         if (window.navigator && window.navigator.msSaveOrOpenBlob) {
  //             window.navigator.msSaveOrOpenBlob(blob, fname);
  //         } else {
  //             let objectUrl = URL.createObjectURL(blob);
  //             let link = document.createElement("a");
  //             link.href = objectUrl;
  //             link.setAttribute("download", fname);
  //             document.body.appendChild(link);
  //             link.click();
  //         }

  //     }).catch(res => {

  //     })

  // }).catch(res => {
  //     ElMessage.warning('功能开发中，敬请期待！')
  // })

  // ElMessage.warning('功能开发中，敬请期待！')

  if (type2 == 1) {
    window._czc.push([
      "_trackEvent",
      "省公共服务平台",
      "下载",
      "电子交易系统接入指南下载",
    ]);
  } else {
    window._czc.push([
      "_trackEvent",
      "省公共服务平台",
      "准备环境",
      "电子交易系统接入指南下载",
    ]);
  }

  const a = document.createElement("a");
  

  a.href =
    "S01远程异地评标和评标专家库共享技术标准_电子交易系统接入指南_20250605_1600.pdf";
  a.download =
    "S01远程异地评标和评标专家库共享技术标准_电子交易系统接入指南_20250605_1600.pdf";

  a.click();
};

// 跳转自主模拟测试

const tosharedComponents = (type) => {
  if (type == "1") {
    window.open("http://47.93.12.150/mocktest/", "_blank");
  }
  if (type == "2") {
    window.open("", "_blank");
  }
};

onMounted(async () => {
  await nextTick(); // 等待 DOM 更新
  if (route.query.bottom) {
    // 滚动到距离页面顶部800px的位置
    window.scrollTo({
      top: 900,
      behavior: "smooth", // 可选，用于平滑滚动
    });
  } else {
    window.scrollTo(0, 0);
  }

  //获取平台列表
  // getalllist()
});

//地级市
let reginList = ref([
  {
    id: 11,
    parentId: 0,
    title: "北京市",
    key: "11",
    value: "11",
    hasChildren: true,
  },
  {
    id: 12,
    parentId: 0,
    title: "天津市",
    key: "12",
    value: "12",
    hasChildren: true,
  },
  {
    id: 13,
    parentId: 0,
    title: "河北省",
    key: "13",
    value: "13",
    hasChildren: true,
  },
  {
    id: 14,
    parentId: 0,
    title: "山西省",
    key: "14",
    value: "14",
    hasChildren: true,
  },
  {
    id: 15,
    parentId: 0,
    title: "内蒙古",
    key: "15",
    value: "15",
    hasChildren: true,
  },
  {
    id: 21,
    parentId: 0,
    title: "辽宁省",
    key: "21",
    value: "21",
    hasChildren: true,
  },
  {
    id: 22,
    parentId: 0,
    title: "吉林省",
    key: "22",
    value: "22",
    hasChildren: true,
  },
  {
    id: 23,
    parentId: 0,
    title: "黑龙江省",
    key: "23",
    value: "23",
    hasChildren: true,
  },
  {
    id: 31,
    parentId: 0,
    title: "上海市",
    key: "31",
    value: "31",
    hasChildren: true,
  },
  {
    id: 32,
    parentId: 0,
    title: "江苏省",
    key: "32",
    value: "32",
    hasChildren: true,
  },
  {
    id: 33,
    parentId: 0,
    title: "浙江省",
    key: "33",
    value: "33",
    hasChildren: true,
  },
  {
    id: 34,
    parentId: 0,
    title: "安徽省",
    key: "34",
    value: "34",
    hasChildren: true,
  },
  {
    id: 35,
    parentId: 0,
    title: "福建省",
    key: "35",
    value: "35",
    hasChildren: true,
  },
  {
    id: 36,
    parentId: 0,
    title: "江西省",
    key: "36",
    value: "36",
    hasChildren: true,
  },
  {
    id: 37,
    parentId: 0,
    title: "山东省",
    key: "37",
    value: "37",
    hasChildren: true,
  },
  {
    id: 41,
    parentId: 0,
    title: "河南省",
    key: "41",
    value: "41",
    hasChildren: true,
  },
  {
    id: 42,
    parentId: 0,
    title: "湖北省",
    key: "42",
    value: "42",
    hasChildren: true,
  },
  {
    id: 43,
    parentId: 0,
    title: "湖南省",
    key: "43",
    value: "43",
    hasChildren: true,
  },
  {
    id: 44,
    parentId: 0,
    title: "广东省",
    key: "44",
    value: "44",
    hasChildren: true,
  },
  {
    id: 46,
    parentId: 0,
    title: "海南省",
    key: "46",
    value: "46",
    hasChildren: true,
  },
  {
    id: 45,
    parentId: 0,
    title: "广西",
    key: "45",
    value: "45",
    hasChildren: true,
  },

  {
    id: 50,
    parentId: 0,
    title: "重庆市",
    key: "50",
    value: "50",
    hasChildren: true,
  },
  {
    id: 51,
    parentId: 0,
    title: "四川省",
    key: "51",
    value: "51",
    hasChildren: true,
  },
  {
    id: 52,
    parentId: 0,
    title: "贵州省",
    key: "52",
    value: "52",
    hasChildren: true,
  },
  {
    id: 53,
    parentId: 0,
    title: "云南省",
    key: "53",
    value: "53",
    hasChildren: true,
  },
  {
    id: 54,
    parentId: 0,
    title: "西藏",
    key: "54",
    value: "54",
    hasChildren: true,
  },
  {
    id: 61,
    parentId: 0,
    title: "陕西省",
    key: "61",
    value: "61",
    hasChildren: true,
  },
  {
    id: 62,
    parentId: 0,
    title: "甘肃省",
    key: "62",
    value: "62",
    hasChildren: true,
  },
  {
    id: 63,
    parentId: 0,
    title: "青海省",
    key: "63",
    value: "63",
    hasChildren: true,
  },
  {
    id: 64,
    parentId: 0,
    title: "宁夏",
    key: "64",
    value: "64",
    hasChildren: true,
  },
  {
    id: 65,
    parentId: 0,
    title: "新疆",
    key: "65",
    value: "65",
    hasChildren: true,
  },

  {
    id: 99,
    parentId: 0,
    title: "新疆兵团",
    key: "99",
    value: "99",
    hasChildren: true,
  },
]);

//地级市
let noreginList = ref([]);

//省级
let platformList = ref([
  {
    createTime: "2024-12-19 09:15:44",
    provinceName: "湖北省",
    provinceCode: "42",
    isNew: true,
    sort: 5,
    platformList: [],
    firstPlatform: {
      id: "1869552157550780418",
      platformCode: "",
      platformName: "湖北省电子招投标交易平台",
      platformUrl: "",
      platformOrgName: "湖北省公共资源交易中心",
      platformOrgCode: "12420000767423658J",
      platformContactName: "何处",
      platformContactPhone: "15392940611",
      platformLogo: require("@/assets/img/hblogo2.png"),
      createUserName: "",
      updateUserName: "",
      createTime: "2025/03/30 12:25:28",
      platformRegionName: "湖北省",
    },
  },
]);
noreginList.value = reginList.value.filter(
  (item) => !platformList.value.some((item2) => item2.provinceCode == item.key)
);
let cityList = ref([{ platformList: [] }]);

//总数
let total = ref(0);

let PlatformParms = ref({
  platformName: "",
});

//搜索平台列表
let searchPlatform = ref([]);

//是否搜索
let isSearch = ref(false);
//是否显示更多按钮
let showmoreBtn = ref(false);
//当前页数
let currentPage = ref(1);
//搜索平台列表方法
const getalllist = (platformName) => {
  let nowUrl = window.location.href;
  // 搜索
  if (platformName) {
    isSearch.value = true;
    let parms = {
      platformName: platformName,
      current: 1,
      size: 12,
      ascs: "create_time",
    };
    showmoreBtn.value = false;
    getPublishPlatform(parms).then((res) => {
      searchPlatform.value = res.data.records;

      // if (nowUrl.includes('cashare.cebpubservice.com')){
      //     //生产环境置空
      //     searchPlatform.value = []
      // }

      // searchPlatform.value = []
      searchPlatform.value.map((item) => {
        item.isHovered = false;
      });

      if (res.data.total > res.data.size * res.data.current) {
        showmoreBtn.value = true;
      }
      currentPage.value = res.data.current;
    });
  } else {
    // 初始化
    getProvincePlatformCatalog({}).then((res) => {
      isSearch.value = false;

      platformList.value = res.data.provinceList;

      // platformList.value = []

      // if (nowUrl.includes('cashare.cebpubservice.com')){
      //     //生产环境置空
      //    platformList.value = []
      // }

      let filteredList1 = reginList.value.filter(
        (item) =>
          !platformList.value.some((item2) => item2.provinceCode == item.key)
      );

      noreginList.value = filteredList1;

      platformList.value.map((item: any) => {
        res.data.latestProvincePlatformIdList.map((item3) => {
          //省级最新标签
          if (item3 == item.firstPlatform.id) {
            item.isNew = true;
          }
        });
      });

      cityList.value = JSON.parse(JSON.stringify(reginList.value));
      let mergedCityList = cityList.value.map((item: any) => {
        // 查找 res.data.cityList 中与当前 item.value 相等的 provinceCode
        const match = res.data.cityList.find(
          (item2: any) => item.value === item2.provinceCode
        );
        // 如果找到了匹配项，则合并两个对象
        if (match) {
          // 使用扩展运算符 {...} 来合并对象
          return { ...item, ...match };
        }
        // 如果没有找到匹配项，则返回原始对象
        return item;
      });

      cityList.value = mergedCityList;

      // if (nowUrl.includes('cashare.cebpubservice.com')){
      //     //生产环境置空
      //     cityList.value= cityList.value

      // }else{
      //     cityList.value = mergedCityList

      // }

      cityList.value.map((item) => {
        if (!item.platformList) {
          item.platformList = [];
        }

        if (item.platformList) {
          total.value = total.value + item.platformList.length;
          if (item.platformList.length > 0) {
            item.platformList[item.platformList.length - 1].isNew = true;
          }
        }
      });

      cityList.value = cityList.value.filter((item) => item.id !== 99);
    });
  }
};
//展示城市名称
const showcity = (address) => {
  if (address) {
    // 按照逗号分割字符串
    const parts = address.split(",");
    // 检查是否有足够的部分来包含市级
    if (parts.length >= 2) {
      // 返回第二个部分（市级），并去除可能存在的空格
      return parts[1].trim();
    } else {
      return parts[0].trim(); // 或者你可以决定返回null/''来表示错误
    }
  } else {
    return "";
  }
};

//查看更多，下一页
const addPage = (platformName) => {
  isSearch.value = true;

  let parms = {
    platformName: platformName,
    current: currentPage.value + 1,
    size: 12,
    ascs: "create_time",
  };
  showmoreBtn.value = false;
  getPublishPlatform(parms).then((res) => {
    searchPlatform.value = [...searchPlatform.value, ...res.data.records];
    searchPlatform.value.map((item) => {
      item.isHovered = false;
      item.isHovered2 = false;
    });

    if (res.data.total > res.data.size * res.data.current) {
      showmoreBtn.value = true;
    } else {
      showmoreBtn.value = false;
    }

    currentPage.value = res.data.current;
  });
};

//控制弹框
let showoverlay = ref(false);
//平台信息
let systeminfo = ref({ systemList: [{ tradingSystemName: "" }] });
//点击,判断只有一个平台跳转平台,多个平台弹框
const toPlatform = (item) => {
  if (item.systemList.length > 1) {
    showoverlay.value = true;
    systeminfo.value = item;
  } else {
    window.open(item.systemList[0].tradingSystemUrl, "_blank");
  }
};
// 跳转平台
const toPlatformUrl = (item) => {
  window.open(item.tradingSystemUrl, "_blank");
};

//跳转共享组件页面
const toSharedComponents = (tip) => {
  router.push({
    path: "/sharedComponents",
    query: {
      tip: tip,
    },
  });
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/step.scss";

.banner {
  width: 100%;
  height: 577px;
  position: relative;
  background: url("../../assets/img/banner2/9-1.png") no-repeat center center;
  background-size: cover;

  .banner-center {
    width: 1200px;
    position: absolute;
    left: 50%;
    transform: translate(-50%);
    display: flex;
    justify-content: space-between;
    top: 116px;
  }

  .textbox {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .banner-img {
    height: 413px;
    margin-right: -124px;
    margin-top: 42px;
  }

  .banner-text1 {
    color: var(--Color-Neutral-neutral-11, #323335);

    font-size: 36px;
    font-style: normal;
    font-weight: 600;
    line-height: 70px;
    text-align: left;
  }

  .banner-text2 {
    color: var(--Color-Neutral-neutral-10, #64666b);
    text-align: center;

    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    text-align: left;
  }
}

.box1 {
  // background: #F8F9FF;
  width: 100%;
  height: 850px;
  padding: 1px 0 0 0;
}

:deep(.el-input__wrapper) {
  box-shadow: 0 0 0 0px var(--el-input-border-color, var(--el-border-color))
    inset;
  cursor: default;
  border: none !important;
}

.box2 {
  width: 100%;

  .box2-top {
    width: 100%;
    height: 311px;
    background: url("../../assets/img/banner/search.webp") no-repeat center
      center;
    background-size: 100% 100%;
    padding: 1px;
    box-sizing: border-box;

    .search {
      width: 600px;
      margin: 0 auto;
      display: flex;
      height: 42px;
      background: #fff;
      align-items: center;
      border-radius: var(--Radius-Border-radius-3, 4px);
      padding: 0 3px 0 10px;
      margin-top: 48px;
    }
  }

  .platformtype-title {
    height: 48px;
    color: #000;

    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 48px;
  }

  .content {
    width: 1200px;
    margin: 0 auto;

    border-radius: var(--Radius-Border-radius-3, 4px);
    border: var(--Radius-Border-radius-2, 2px) solid #fff;
    background-color: #fff;
    box-shadow: 8px 8px 20px 0px rgba(55, 99, 170, 0.1);
    margin-top: -40px;
    padding: 0 24px 32px 24px;
    box-sizing: border-box;

    .contentbox {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;

      .center {
        width: 192px;
        height: 140px;
        overflow: hidden;
        display: flex;
        /* 设置为Flex容器 */
        justify-content: center;
        /* 水平居中子元素 */
        align-items: center;
        /* 垂直居中子元素 */
        padding: 24px;
        box-sizing: border-box;
        position: relative;

        .new-tag {
          position: absolute;
          top: 0;
          right: 0;
          width: 90px;
          height: 22px;
        }
      }

      .center2 {
        width: 192px;
        height: 140px;
        padding: 20px 15px;
        box-sizing: border-box;
        border-radius: var(--Radius-Border-radius-4, 8px);
        border: var(--Radius-Border-radius-2, 2px) solid
          var(--Text-Text-4, #f4f4f5);
        background: #fff;
        box-shadow: 8px 8px 20px 0px rgba(55, 99, 170, 0.1);

        .top2 {
          width: 100%;
          text-align: center;
          box-sizing: border-box;
          display: flex;
        }

        .appimgn {
          // width: 162px;
          max-width: 144px;
          height: 42px;
          margin: 0 auto;
          margin-top: 0 !important;
        }

        .text0 {
          color: var(--Color-Neutral-neutral-10, #64666b);

          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 22px;
          letter-spacing: 0.028px;
          margin-top: 10px;
        }

        .text1 {
          color: var(--Color-Neutral-neutral-10, #64666b);

          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 22px;
          letter-spacing: 0.028px;
          display: flex;
        }

        .text2 {
          color: var(--Color-Neutral-neutral-9, #969aa0);

          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 22px;
          display: flex;
        }

        .text3 {
          color: var(--Color-Branding-blue, #3461ff);

          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 22px;
          width: 60px;
          text-align: right;
          cursor: pointer;
        }
      }

      .noplatform {
        color: #bfc1c5;
        text-align: center;
        font-size: 24px;
        font-style: normal;
        font-weight: 500;
        line-height: 28px;
      }
    }

    .municipality-title {
      display: flex;
      justify-content: space-between;
      // border-bottom: 1px solid #F3F3F4;
      padding: 0 48px 0 24px;
      box-sizing: border-box;
      align-items: center;

      .municipality-name {
        color: var(--Text-neutral-11, #323335);

        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 36px;
      }

      .municipality-total {
        color: #4b5b76;

        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px;
      }
    }

    .contentbox2 {
      display: flex;
      // margin-top: 5px;
      // overflow: hidden;
      overflow-x: clip;
      width: 1153px;

      .center {
        width: 192px;
        height: 140px;
        // overflow: hidden;
        overflow-x: clip;

        display: flex;
        /* 设置为Flex容器 */
        justify-content: center;
        /* 水平居中子元素 */
        align-items: center;
        /* 垂直居中子元素 */
        padding: 24px;
        box-sizing: border-box;
        position: relative;
        border-top: #f3f3f4 1px solid;

        .new-tag {
          position: absolute;
          top: -5px;
          right: 1px;
          width: 90px;
          height: 22px;
        }
      }

      .center2 {
        width: 192px;
        height: 140px;
        padding: 20px 15px;
        box-sizing: border-box;
        border-radius: var(--Radius-Border-radius-4, 8px);
        border: 2px solid var(--Text-Text-4, #f4f4f5);
        background: #fff;
        box-shadow: 8px 8px 20px 0px rgba(55, 99, 170, 0.1);

        .top2 {
          width: 100%;
          text-align: center;
          box-sizing: border-box;
          display: flex;
        }

        .appimgn {
          // width: 162px;
          max-width: 144px;
          height: 42px;
          margin: 0 auto;
          margin-top: 0 !important;
        }

        .text0 {
          color: var(--Color-Neutral-neutral-10, #64666b);

          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 22px;
          letter-spacing: 0.028px;
          margin-top: 10px;
        }

        .text1 {
          color: var(--Color-Neutral-neutral-10, #64666b);

          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 22px;
          letter-spacing: 0.028px;
          display: flex;
        }

        .text2 {
          color: var(--Color-Neutral-neutral-9, #969aa0);

          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 22px;
          display: flex;
        }

        .text3 {
          color: var(--Color-Branding-blue, #3461ff);

          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 22px;
          width: 60px;
          text-align: right;
          cursor: pointer;
        }
      }

      .noplatform {
        color: #bfc1c5;
        text-align: center;
        font-size: 24px;
        font-style: normal;
        font-weight: 500;
        line-height: 28px;
      }
    }
  }
}

.successtip {
  color: var(--Text-Text-10, #64666b);

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  padding: 0 20px;
}

.card-bottom {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}

.btn1 {
  background-color: #3461ff;
  height: 40px;
  width: 50%;
  font-size: 14px;
  border: none;
}

.btn2 {
  color: #3461ff;
  border-color: #3461ff;
  height: 40px;
  width: 50%;
  font-size: 14px;
  border: 1px solid #3461ff;
}

.btn2:hover {
  color: #fff;
  background-color: #3461ff;
  border-color: #3461ff;
}

.searchbtn {
  background-color: #3461ff;
  width: 120px;
  font-size: 14px;
  height: 32px;
  border: none;
}

.paperview-input-text {
  font-size: 14px;
  height: 32px;
}

.appimgbox {
  // width: 144px;
  height: 50px;
  margin: 0 auto;
  overflow: hidden;
}

.infobox {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;

  .text-box {
    color: var(--Text-neutral-10, #64666b);
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 21px;
    height: 21px;
    padding: 0px 7px;
    border-radius: var(--Radius-Border-radius-2, 2px);
    background: linear-gradient(
        0deg,
        rgba(255, 255, 255, 0.9) 0%,
        rgba(255, 255, 255, 0.9) 100%
      ),
      var(--Branding-Blue-6, #3461ff);

    overflow: hidden;
    /* 保持文本在一行内 */
    white-space: nowrap;
    /* 文本超出时显示省略号 */
    text-overflow: ellipsis;
  }

  .text-box1 {
    color: var(--Text-neutral-10, #64666b);
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 21px;
    height: 21px;
    padding: 0px 7px;
    border-radius: var(--Radius-Border-radius-2, 2px);
    background: linear-gradient(
        0deg,
        rgba(255, 255, 255, 0.9) 0%,
        rgba(255, 255, 255, 0.9) 100%
      ),
      var(--Branding-Blue-6, #3461ff);
    max-width: 50px;
    overflow: hidden;
    /* 保持文本在一行内 */
    white-space: nowrap;
    /* 文本超出时显示省略号 */
    text-overflow: ellipsis;
  }

  // .info-text {
  //     color: var(--Color-Neutral-neutral-10, #64666B);
  //
  //     font-size: 14px;
  //     font-style: normal;
  //     font-weight: 500;
  //     line-height: 22px;
  //     white-space: nowrap;
  //     overflow: hidden;
  //     text-overflow: ellipsis;
  //     // width: 100px;

  // }
}

.btnmore {
  border-radius: var(--Radius-Border-radius-3, 4px);
  border: 1px solid var(--Text-neutral-6, #dfe0e2);
  background: #fff;
  color: var(--Text-Text-11, #323335);
  text-align: center;

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 40px;
  width: 122px;
  height: 40px;
  margin: 0 auto;
  cursor: pointer;
}

.btnmore:hover {
  color: #3461ff;
  border: var(--Radius-Border-radius-1, 1px) solid
    var(--Branding-Blue-6, #3461ff);
}

.tonext {
  width: 32px;
  height: 60px;
}

.icobox {
  font-size: 20px;
  height: 60px;
  line-height: 60px;
  width: 32px;
  text-align: center;
}

.morebox {
  width: 100%;
  text-align: center;
  height: 100px;
}

.myoverlay {
  background-color: var(--el-overlay-color-lighter);
  bottom: 0;
  height: 100%;
  left: 0;
  overflow: hidden;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 2000;
}

.mydialog {
  margin: 0 auto;
  margin-top: 200px;
  width: 1200px;
  // height: 313px;
  // height: 100%;
  padding: 64px;
  box-sizing: border-box;
  border-radius: var(--Radius-Border-radius-4, 8px);
  background: conic-gradient(
    from 90deg at 100% 100%,
    #fafbff 44.00728762149811deg,
    #f7f9ff 65.94390571117401deg,
    #f7faff 90deg,
    #f8fcff 150.71987986564636deg,
    #ecf6ff 215.2921199798584deg
  );

  .dialogtitle {
    color: #000;
    text-align: center;

    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 40px;
    // margin-top: 64px;
  }

  .numbox {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    width: 90%;
    margin-top: 24px;
  }

  .dtext {
    color: #999;
    text-align: center;

    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 40px;
    /* 250% */
  }

  .dtext2 {
    color: #999;
    text-align: center;

    font-size: 13px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    min-width: 150px;
  }

  .dtext3 {
    color: var(--Color-Branding-blue, #3461ff);

    font-size: 13px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
  }

  .dline {
    width: 100%;
    height: 1px;
    background: var(--Color-Auxiliary-auxiliary-2, #d7d7dc);
  }
}

.systeminfoBox {
  display: flex;
  flex-wrap: wrap;
  margin-top: 30px;
  // justify-content: center;

  /* 允许子元素换行 */
  // margin: -1px;
  /* 通过负外边距来调整边框重叠问题 */
}

.systeminfoBox2 {
  display: flex;
  flex-wrap: wrap;
  margin-top: 30px;
  justify-content: center;
}

.systemItem {
  box-sizing: border-box;
  border: 1px solid #d7d7dc;
  text-align: center;
  height: 40px;
  line-height: 40px;
  width: 33%;
  color: var(--Color-Neutral-neutral-11, #323335);
  text-align: center;
  width: 33.333%;
  margin-top: 17px;
  cursor: pointer;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
}

.systemItem:hover {
  // border-color: #3461FF;
  // color: #3461FF;
  // background: #EFF9FF;
  /* 鼠标悬停时边框颜色变为蓝色 */
  z-index: 1;
  /* 提升层级，确保边框显示在上层 */
  background: #3461ff;
  color: #ffffff;
  border-radius: 4px;
}

.stepbox {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.bottonbox {
  display: flex;
  margin-top: 24px;
  justify-content: space-evenly;
  padding: 0 10px;
}

.bottonbox2 {
  display: flex;
  margin-top: 24px;
  padding: 0 12px;

  .btn-title {
    color: #969aa0;
    text-align: left;

    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
  }

  .btn-text {
    color: #3461ff;
    text-align: center;

    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    cursor: pointer;
  }
}

.bottonbox3 {
  margin-top: 24px;
  padding: 0 12px;

  .btn-title {
    color: #969aa0;
    text-align: left;

    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    width: 100px;
  }

  .btn-text {
    color: #3461ff;
    text-align: center;

    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    cursor: pointer;
  }
}

.point {
  color: #4e5969;
  font-size: 30px;
}

.info-text3 {
  color: var(--Text-neutral-9, #969aa0);

  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  /* 150% */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.appimg3 {
  width: 90px;
  height: 90px;
}

.swiper-button-prev {
  width: 10px !important;
  height: 10px !important;
}

.delStep {
  color: #97a3b7;
  width: 34px;
  height: 34px;
  padding: 7px;
  border-radius: 17px;
  border: var(--Radius-Border-radius-2, 2px) solid #fff;
  background: linear-gradient(0deg, #fff 0%, #f3f5f8 100%);
  box-shadow: 8px 8px 20px 0px rgba(55, 99, 170, 0.1),
    -8px -8px 20px 0px rgba(255, 255, 255, 0.8);
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
}

.swiper-button-prev:after {
  display: none;
}

.swiper-button-next:after {
  font-size: 10px;
  display: none;
}

.searchBox {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
  margin-top: 15px;

  .center {
    width: 192px;
    height: 140px;
    overflow: hidden;
    display: flex;
    /* 设置为Flex容器 */
    justify-content: center;
    /* 水平居中子元素 */
    align-items: center;
    /* 垂直居中子元素 */
    padding: 24px;
    box-sizing: border-box;
  }

  .center2 {
    width: 192px;
    height: 140px;
    padding: 20px 15px;
    box-sizing: border-box;
    border-radius: var(--Radius-Border-radius-4, 8px);
    border: var(--Radius-Border-radius-2, 2px) solid var(--Text-Text-4, #f4f4f5);
    background: #fff;
    box-shadow: 8px 8px 20px 0px rgba(55, 99, 170, 0.1);

    .top2 {
      width: 100%;
      text-align: center;
      box-sizing: border-box;
      display: flex;
    }

    .appimgn {
      // width: 162px;
      max-width: 144px;
      height: 42px;
      margin: 0 auto;
      margin-top: 0 !important;
    }

    .text0 {
      color: var(--Color-Neutral-neutral-10, #64666b);

      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 22px;
      letter-spacing: 0.028px;
      margin-top: 10px;
    }

    .text1 {
      color: var(--Color-Neutral-neutral-10, #64666b);

      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 22px;
      letter-spacing: 0.028px;
      display: flex;
    }

    .text2 {
      color: var(--Color-Neutral-neutral-9, #969aa0);

      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 22px;
      display: flex;
    }

    .text3 {
      color: var(--Color-Branding-blue, #3461ff);

      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 22px;
      width: 60px;
      text-align: right;
      cursor: pointer;
    }
  }

  .noplatform {
    color: #bfc1c5;
    text-align: center;
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: 28px;
  }
}

.mySwiper {
  padding: 10px 0 0 0;
}

.nodata {
  width: 100%;
  text-align: center;
  padding: 60px 0 40px 0;

  .text1 {
    color: var(--Text-neutral-11, #323335);

    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
  }

  .text2 {
    color: var(--Text-neutral-9, #969aa0);

    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    margin-top: 10px;
  }
}

.cityName {
  width: 77px;
  height: 24px;
  line-height: 24px;

  color: #fff;
  position: absolute;
  left: 0;
  bottom: 0;
  text-align: center;
  // border-radius: 0 15px 0 8px !important;
  font-size: 12px;
  background-image: url(../../assets/img/tradingSystem/city-bg.png);
  background-size: contain;
  background-repeat: no-repeat;
}

.stepitembg {
  height: 290px;
  padding: 20px 0;
  position: relative;
}

.stepitem:hover {
  height: 290px !important;
}
</style>
